/** Voir `stackOffsetPx`. `position` à `null` : widget non monté, il ne compte jamais. */
export interface StackedWidget {
  position: string | null;
  heightPx: number;
  visible: boolean;
  /** Remplace `StackMetrics.gapPx` au-dessus de CE widget, pour détacher un bloc du reste. */
  gapAfterPx?: number;
}

export interface StackMetrics {
  /** Marge entre le bord de la carte et le premier widget. */
  baseEdgeOffsetPx: number;
  gapPx: number;
}

/**
 * Décalage (px) depuis le bord, sachant les widgets `below` qui précèdent dans la pile (du bord vers
 * l'intérieur). Ceux d'un autre coin ou masqués sont ignorés : la pile se resserre au lieu de garder
 * un trou. Somme les hauteurs RÉELLES plutôt qu'un pas fixe — la recherche fait ~37px et les boutons
 * ~36, un pas unique chevaucherait dans un cas ou laisserait un vide dans l'autre.
 */
export function stackOffsetPx(position: string, below: StackedWidget[], metrics: StackMetrics): number {
  return below
    .filter((widget) => widget.position === position && widget.visible)
    .reduce((offset, widget) => offset + widget.heightPx + (widget.gapAfterPx ?? metrics.gapPx), metrics.baseEdgeOffsetPx);
}
